import type {CpcCampaignListItem} from './types';

import {dateToReadableDate} from '@date-picker';
import {Chip, Loading} from '@ds/components';
import {getStatusChipProps} from 'common/status-chip/getStatusChipProps';
import InfiniteScroll from 'react-infinite-scroll-component';
import {useNavigate} from 'react-router-dom';

import {getCpcStateLabel} from '../../../utils';

type CampaignListProps = {
  campaigns: CpcCampaignListItem[];
  hasMore: boolean;
  isLoadingMore: boolean;
  onLoadMore: () => void;
};

const CampaignList: React.FC<CampaignListProps> = ({
  campaigns,
  hasMore,
  isLoadingMore,
  onLoadMore
}) => {
  const navigate = useNavigate();

  return (
    <InfiniteScroll
      next={onLoadMore}
      dataLength={campaigns.length}
      scrollableTarget="cpc-list"
      hasMore={hasMore}
      loader={
        isLoadingMore ? (
          <div className="flex h-10 justify-center">
            <Loading size="medium" color="primary" />
          </div>
        ) : null
      }
      scrollThreshold={0.6}
    >
      <div className="flex flex-col">
        {campaigns.map((campaign) => {
          const state = campaign.hold ? 'paused' : campaign.state;
          const chipProps = getStatusChipProps(state);

          return (
            <button
              type="button"
              key={campaign.id}
              className="flex w-full items-center justify-between gap-3 border-b border-gray-03 px-4 py-3 text-start focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange"
              onClick={() => navigate(`/cpc/details/${campaign.id}`)}
            >
              <span className="flex min-w-0 flex-1 flex-col">
                <span className="text-body-sm-emphasis text-neutral-fg">
                  {campaign.demand_click_count} کلیک درخواستی
                </span>
                <span className="text-body-sm text-gray-07">
                  {dateToReadableDate({
                    date: campaign.start_date,
                    month: true,
                    day: true
                  })}
                  {campaign.end_date
                    ? ` تا ${dateToReadableDate({
                        date: campaign.end_date,
                        month: true,
                        day: true
                      })}`
                    : ''}
                </span>
              </span>
              <Chip
                label={getCpcStateLabel(state)}
                variant={chipProps.variant}
                color={chipProps.color}
                size="sm"
                interactive={false}
              />
            </button>
          );
        })}
      </div>
    </InfiniteScroll>
  );
};

export default CampaignList;
